import {addClass, makeRequest, removeClass} from './../supports/utils';

class FeedbackForm {
    init() {
        this.container = document.getElementById('feedback');

        if (!this.container) {
            return;
        }

        this.form = this.container.querySelector('.feedback-form');
        this.buttonsContainer = this.container.querySelector('.buttons');

        this.positiveButton = this.container.querySelector('.button-positive');
        this.negativeButton = this.container.querySelector('.button-negative');

        this.positiveThanks = this.container.querySelector('.thanks-positive');
        this.negativeThanks = this.container.querySelector('.thanks-negative');

        this.initButtons();
        this.negativeComment = new FeedbackNegativeComment(this.container.querySelector('.negative-comment-field'), this);

        this.requestUrl = 'https://script.google.com/a/celtra.com/macros/s/AKfycbz_awXHUo9Yur8lyN6n0gJ7NB1L9psIVhknItAO/exec';
    }

    initButtons() {
        this.positiveButton.addEventListener('click', e => {
            e.preventDefault();

            this.handlePositiveMark();
        });

        this.negativeButton.addEventListener('click', e => {
            e.preventDefault();

            this.hideButtons();
            this.negativeComment.show();
        });
    }

    async handlePositiveMark() {
        try {
            this.hideButtons();

            await this.submitScore(1);

            this.showThanks(this.positiveThanks);
        } catch (e) {
            // TODO
            alert(e);
        }
    }

    async handleNegativeMark(data) {
        // simple, very simple validation
        if (data.comment === '') {
            return;
        }

        try {
            this.hideButtons();
            this.negativeComment.hide();

            await this.submitScore(-1);

            this.negativeComment.clear();
            this.showThanks(this.negativeThanks);
        } catch (e) {
            // TODO
            alert(e);
        }
    }

    async submitScore(score) {
        const formData = new FormData(this.form);
        formData.append('score', score);

        return makeRequest('POST', this.requestUrl, formData)
    }

    showButtons() {
        removeClass(this.buttonsContainer, 'hidden');
    }

    hideButtons() {
        addClass(this.buttonsContainer, 'hidden');
    }

    showThanks(thanksElement) {
        removeClass(thanksElement, 'hidden');
    }
}

class FeedbackNegativeComment {
    constructor(container, parent) {
        this.container = container;
        this.parent = parent;

        this.submitButton = this.container.querySelector('.submit-button');
        this.cancelButton = this.container.querySelector('.cancel-button');

        this.commentField = this.container.querySelector('textarea[name="comment"]');
        this.errorMessage = this.container.querySelector('.error-message');

        this.initCommentField();
        this.initSubmitButton();
        this.initCancelButton();
    }

    initCommentField() {
        new FieldCounter(
            this.commentField,
            this.commentField.parentNode.querySelector('.counter')
        );
    }

    initSubmitButton() {
        this.submitButton.addEventListener('click', e => {
            e.preventDefault();

            if (!this.commentField.value.trim()) {
                this.showErrorMessage()
                return
            }

            this.hideErrorMessage()
            this.parent.handleNegativeMark({
                comment: this.commentField.value,
            });
        });
    }

    initCancelButton() {
        this.cancelButton.addEventListener('click', e => {
            e.preventDefault();

            this.hide();
            this.clear();
            this.parent.showButtons();
        });
    }

    showErrorMessage() {
        this.errorMessage.classList.remove('invisible')
        this.commentField.focus()
    }

    hideErrorMessage() {
        this.errorMessage.classList.add('invisible')
    }

    show() {
        removeClass(this.container, 'hidden');
        this.commentField.focus();
    }

    hide() {
        addClass(this.container, 'hidden');
    }

    clear() {
        this.commentField.value = '';
        this.hideErrorMessage()
    }
}

class FieldCounter {
    constructor(field, counter) {
        this.field = field;
        this.counter = counter;

        this.init();
    }

    init() {
        this.field.addEventListener('input', e => {
            this.counter.innerText = e.target.value.length;
        });
    }
}

export default new FeedbackForm();
